import styled from 'styled-components'

import CommonButton from 'components/Button/CommonButton'
import theme from 'theme_'
import { SectionLabel } from 'components/Typography'
import { CommonLinkButton } from 'components/Button'

const { colors } = theme

export const SubscriptionInfoStyledManageButton = styled(CommonButton)`
  width: 127px;
  height: 40px;
`

export const SubscriptionInfoBlock = styled.div`
  height: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  align-content: space-between;
`
export const SubscriptionInfoPlanInfo = styled.div`
  flex: 1 1 100%;
  padding-bottom: 10px;
`

export const SubscriptionInfoPlanBlock = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  align-content: center;
`

export const SubscriptionInfoManagedByBlock = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  flex: 1 1 100%;
`
export const SubscriptionInfoManagedByUserBlock = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  align-content: center;
  justify-content: space-between;
`

export const SubscriptionInfoExpiryLabel = styled(SectionLabel)<{
  $hasWarn?: boolean
}>`
  margin-bottom: 0px;
  line-height: 20px;
  text-align: right;
  color: ${(p) => (p.$hasWarn ? colors.error : colors.moreGrey)};
`

export const SubscriptionInfoManageByText = styled(SectionLabel)`
  flex: 1 1 100%;
  margin-bottom: 0px;
`
export const SubscriptionInfoExpireBlock = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
`

export const SubscriptionInfoManagedByLabel = styled.span`
  margin-top: 2px;
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
  display: flex;
  flex: 1;
`

export const SubsInfoBottomSection = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
`

export const SubsInfoBottomSectionLeftBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
`

export const SubsInfoTooltipWrapper = styled.div`
  div {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const SubsInfoCancelSubscription = styled(CommonLinkButton)`
  text-align: left;
`
